import type { GpReviewFilter } from './types';

export const GROWTH_GBP_PHOTOS_META = {
  eyebrow: 'Google Business Profile · Photos',
  titleLead: 'GBP',
  titleAccent: 'photos',
  description:
    "Profiles with 20+ recent photos rank higher in the Map Pack. ELVA identifies what's missing, shows examples, and syncs your uploads automatically.",
} as const;

export const GROWTH_GBP_PHOTOS_BULK_META = {
  eyebrow: 'Google Business Profile · Photos',
  titleLead: 'Bulk upload',
  titleAccent: 'photos',
  description:
    "Upload multiple photos at once. ELVA's AI categorizes, matches, and checks quality before you sync to Google.",
} as const;

export const GP_PRIORITY_LABEL: Record<'essential' | 'recommended' | 'nice', string> = {
  essential: 'Essential',
  recommended: 'Recommended',
  nice: 'Nice to have',
};

export const GP_BULK_STEPS = [
  { id: 'upload', label: 'Upload' },
  { id: 'processing', label: 'AI Analysis' },
  { id: 'review', label: 'Review' },
  { id: 'success', label: 'Sync' },
] as const;

export const GP_REVIEW_FILTERS: readonly GpReviewFilter[] = [
  { id: 'all', label: 'All photos' },
  { id: 'ready', label: 'Ready to sync' },
  { id: 'warning', label: 'Need review' },
  { id: 'uncategorized', label: 'Uncategorized' },
  { id: 'rejected', label: 'Rejected' },
] as const;

export const GP_REVIEW_CATEGORIES: readonly string[] = [
  'Essential',
  'Interior',
  'Team',
  'Equipment',
  'Procedures',
  'Before/After',
  'Exterior',
] as const;
